"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[75163],{

/***/ 75163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SSOManager; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/SSO.ts


var getDKTToken = function(code, redirectUri) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.token */.KU.token,
        params: {
            code: code,
            redirectUri: redirectUri
        }
    });
};
var atlanticLogin = function(code, redirectUri) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.atlanticLogin */.KU.atlanticLogin,
        data: {
            code: code,
            redirectUri: redirectUri
        },
        hasLocale: false
    });
};

;// CONCATENATED MODULE: ./redux/actions/SSO.ts

var ACTIONS = {
    GET_TOKEN_REQUEST: 'GET_TOKEN_REQUEST',
    GET_TOKEN_SUCCESS: 'GET_TOKEN_SUCCESS',
    GET_TOKEN_FAILURE: 'GET_TOKEN_FAILURE',
    ATLANTIC_LOGIN_REQUEST: 'ATLANTIC_LOGIN_REQUEST',
    ATLANTIC_LOGIN_SUCCESS: 'ATLANTIC_LOGIN_SUCCESS',
    ATLANTIC_LOGIN_FAILURE: 'ATLANTIC_LOGIN_FAILURE'
};
var GET_TOKEN_REQUEST = function() {
    return {
        type: ACTIONS.GET_TOKEN_REQUEST
    };
};
var GET_TOKEN_SUCCESS = function(token) {
    return {
        type: ACTIONS.GET_TOKEN_SUCCESS,
        token: token
    };
};
var GET_TOKEN_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_TOKEN_FAILURE,
        err: err
    };
};
function SSO_getDKTToken(code, redirectUri) {
    return function(dispatch) {
        dispatch(GET_TOKEN_REQUEST());
        return getDKTToken(code, redirectUri).then(function(response) {
            return dispatch(GET_TOKEN_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_TOKEN_FAILURE(err));
        });
    };
}
var ATLANTIC_LOGIN_REQUEST = function() {
    return {
        type: ACTIONS.ATLANTIC_LOGIN_REQUEST
    };
};
var ATLANTIC_LOGIN_SUCCESS = function(data) {
    return {
        type: ACTIONS.ATLANTIC_LOGIN_SUCCESS,
        data: data
    };
};
var ATLANTIC_LOGIN_FAILURE = function(err) {
    return {
        type: ACTIONS.ATLANTIC_LOGIN_FAILURE,
        err: err
    };
};
function SSO_atlanticLogin(code, redirectUri) {
    return function(dispatch) {
        dispatch(ATLANTIC_LOGIN_REQUEST());
        return atlanticLogin(code, redirectUri).then(function(response) {
            return dispatch(ATLANTIC_LOGIN_SUCCESS(response));
        }, function(err) {
            return dispatch(ATLANTIC_LOGIN_FAILURE(err));
        });
    };
}

// EXTERNAL MODULE: ./redux/actions/user.ts
var user = __webpack_require__(76809);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./redux/services/user.ts
var services_user = __webpack_require__(18611);
// EXTERNAL MODULE: ./utils/ssoErrors.ts
var ssoErrors = __webpack_require__(13586);
// EXTERNAL MODULE: ./components/Loader/Loader.tsx
var Loader = __webpack_require__(96149);
;// CONCATENATED MODULE: ./components/SSOManager.tsx
/* provided dependency */ var process = __webpack_require__(34155);












function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var mapStateToProps = function(state) {
    return {
        user: state.user
    };
};
var mapDispatchToProps = {
    getDKTToken: SSO_getDKTToken,
    atlanticLogin: SSO_atlanticLogin,
    getUser: user/* getUser */.PR
};
var SSO_LOGOUT_REDIRECT_PENDING_KEY = 'sso_logout_redirect_pending';
var SSO_LOGIN_IN_PROGRESS_KEY = 'sso_login_in_progress';
var REQUIRED_USER_FIELDS = [
    'firstName',
    'lastName',
    'phoneNumber',
    'gender'
];
var getMissingUserFields = function(userData) {
    return REQUIRED_USER_FIELDS.filter(function(field) {
        var value = userData === null || userData === void 0 ? void 0 : userData[field];
        return typeof value !== 'string' || value.trim() === '';
    });
};
/** OAuth `code` is in the URL before Next router query is hydrated. */ var getOAuthCodeFromLocation = function() {
    if (false) {}
    var params = new URLSearchParams(window.location.search);
    if (params.get('product')) return null;
    return params.get('code');
};
var usesExternalIdpLogout = function(connexionType, userType, store) {
    return userType === 'SSO' && (connexionType === 'decathlon' || store === 'cultura' || store === 'virgin');
};
var SSO = function(param) {
    var children = param.children, getDKTToken1 = param.getDKTToken, atlanticLogin1 = param.atlanticLogin, user = param.user, getUser1 = param.getUser;
    var ref7, ref1, ref2, ref3, ref4;
    var router = (0,next_router.useRouter)();
    var isFunnel = [
        '/information',
        '/shipping',
        '/payment'
    ].includes(router.pathname);
    var currentLocale = router.locale;
    var isThermor = process.env.SSO_TYPE === 'thermor';
    var wasLoggedInRef = (0,react.useRef)(undefined);
    var ssoSessionRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(false), ssoLoginInProgress = ref5[0], setSsoLoginInProgress = ref5[1];
    var ref6 = (0,react.useState)(false), ssoLoginFailed = ref6[0], setSsoLoginFailed = ref6[1];
    var oauthCodeInUrl = getOAuthCodeFromLocation();
    var oauthCode = oauthCodeInUrl || (router.isReady ? (ref7 = router.query) === null || ref7 === void 0 ? void 0 : ref7.code : null);
    var isSsoLoginCallback = Boolean(oauthCode && !(router.isReady && ((ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.product)));
    /** True once this exact `code` has already been processed (e.g. page reload). */ var ssoCodeAlreadyHandled =  true && Boolean(oauthCode) && sessionStorage.getItem(ssoErrors/* SSO_HANDLED_KEY */.cd) === oauthCode;
    /**
   * `ssoLoginInProgress` is React state and is therefore reset to `false` if the
   * component remounts mid-callback (e.g. when the Next router becomes ready).
   * The durable truth lives in sessionStorage and survives the remount, so we
   * read it too. It is gated on an OAuth `code` being present so that a stale
   * flag from a previously interrupted login can never lock a code-less page in
   * the loader.
   */ var ssoLoginInProgressDurable = ssoLoginInProgress || Boolean(oauthCode) && "object" !== 'undefined' && sessionStorage.getItem(SSO_LOGIN_IN_PROGRESS_KEY) === '1';
    /**
   * Homepage exception: the IdP redirects to `/` with `?code=` (+ other query
   * params) to perform the login. An SSO login is still "resolving" while it is
   * in progress, or while a fresh callback code is present that has neither
   * failed nor been handled yet. We must wait for it instead of redirecting the
   * guest away. Once it fails / is stale / completes, this becomes false so we
   * either redirect (guest) or render the page (logged in).
   */ var isSsoLoginResolving = !user.isLoggedIn && (ssoLoginInProgressDurable || isSsoLoginCallback && !ssoLoginFailed && !ssoCodeAlreadyHandled);
    var shouldDeferGuestRedirect = !router.isReady || isSsoLoginResolving;
    var isOnSsoLogoutRedirectPage =  true && Boolean(constants/* ssoLogoutRedirectUrl */.rr) && window.location.href.includes(constants/* ssoLogoutRedirectUrl */.rr);
    var shouldBlockProtectedPage = function() {
        if (!constants/* ssoLogoutRedirectUrl */.rr || isOnSsoLogoutRedirectPage) return false;
        // Actively resolving an SSO login → show the loader, never the page.
        if (isSsoLoginResolving) return true;
        // Still restoring the initial session → outcome unknown yet.
        if (!router.isReady || user.loading || !user.sessionChecked) return true;
        // Guest about to be redirected → don't flash the page.
        if (!user.isLoggedIn) return true;
        return false;
    }();
    var hasStoredAuthToken = function() {
        if (false) {}
        var token = localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
        return token != null && token !== 'null';
    };
    (0,react.useEffect)(function() {
        if (sessionStorage.getItem(SSO_LOGIN_IN_PROGRESS_KEY) === '1') {
            setSsoLoginInProgress(true);
        }
    }, []);
    var redirectToSsoLogoutUrl = function() {
        sessionStorage.removeItem(SSO_LOGOUT_REDIRECT_PENDING_KEY);
        window.location.assign(constants/* ssoLogoutRedirectUrl */.rr);
    };
    var redirectToSsoErrorUrl = function(reason) {
        sessionStorage.setItem(ssoErrors/* SSO_LOGIN_FAILED_KEY */.tt, '1');
        sessionStorage.removeItem(ssoErrors/* SSO_HANDLED_KEY */.cd);
        localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
        window.location.assign((0,ssoErrors/* buildSsoErrorPageUrl */.QQ)(reason));
    };
    var isOnSsoErrorPage = router.isReady && ((0,ssoErrors/* isSsoErrorPageRoute */.bp)(router.pathname, router.query.uid) || router.asPath.includes("/pages/".concat(ssoErrors/* SSO_ERROR_PAGE_UID */.wr)));
    var shouldSkipAutoSsoRedirect = function() {
        return isOnSsoErrorPage ||  true && sessionStorage.getItem(ssoErrors/* SSO_LOGIN_FAILED_KEY */.tt) === '1' ||  true && (0,ssoErrors/* isOnSsoPage */.g8)(window.location.href);
    };
    (0,react.useEffect)(function() {
        if (!constants/* ssoLogoutRedirectUrl */.rr) return;
        if (shouldDeferGuestRedirect) return;
        if (isOnSsoLogoutRedirectPage) return;
        if (shouldSkipAutoSsoRedirect()) return;
        if (!hasStoredAuthToken()) {
            redirectToSsoLogoutUrl();
            return;
        }
        if (user.loading) return;
        if (!user.sessionChecked) return;
        if (!user.isLoggedIn) {
            redirectToSsoLogoutUrl();
        }
    }, [
        user.isLoggedIn,
        user.loading,
        user.sessionChecked,
        router.isReady,
        router.query.uid,
        isSsoLoginCallback,
        ssoLoginInProgress,
        ssoLoginFailed,
        oauthCodeInUrl,
        isOnSsoLogoutRedirectPage, 
    ]);
    (0,react.useEffect)(function() {
        if (user.isLoggedIn) {
            ssoSessionRef.current = {
                connexionType: localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE),
                userType: localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.USER_TYPE */.dA.USER_TYPE),
                store: "adolfo-dominguez"
            };
        }
    }, [
        user.isLoggedIn,
        user === null || user === void 0 ? void 0 : user.user
    ]);
    (0,react.useEffect)(function() {
        var isLoggedIn = !!user.isLoggedIn;
        var wasLoggedIn = wasLoggedInRef.current;
        if (!constants/* ssoLogoutRedirectUrl */.rr) return;
        if (user.loading) return;
        if (!user.sessionChecked) return;
        if (shouldDeferGuestRedirect) return;
        if (wasLoggedIn === true && !isLoggedIn) {
            sessionStorage.setItem(SSO_LOGOUT_REDIRECT_PENDING_KEY, '1');
            var ref = ssoSessionRef.current || {}, connexionType = ref.connexionType, userType = ref.userType, store = ref.store;
            if (!usesExternalIdpLogout(connexionType, userType, store)) {
                redirectToSsoLogoutUrl();
            }
        }
        wasLoggedInRef.current = isLoggedIn;
    }, [
        user.isLoggedIn,
        user.loading,
        user.sessionChecked,
        router.isReady,
        isSsoLoginCallback,
        ssoLoginInProgress,
        oauthCodeInUrl, 
    ]);
    (0,react.useEffect)(function() {
        var ref10, ref8, ref9;
        if (!router.isReady && !oauthCodeInUrl) return;
        if (router.isReady && isThermor && constants/* ssoErrorRedirectUrl */.P$ && (router === null || router === void 0 ? void 0 : (ref10 = router.query) === null || ref10 === void 0 ? void 0 : ref10.error) && !(router === null || router === void 0 ? void 0 : (ref8 = router.query) === null || ref8 === void 0 ? void 0 : ref8.product)) {
            redirectToSsoErrorUrl(null);
            return;
        }
        var code = router.isReady ? router.query.code : oauthCodeInUrl;
        if (!code || router.isReady && ((ref9 = router.query) === null || ref9 === void 0 ? void 0 : ref9.product) || (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN)) === 'null') {
            return;
        }
        if (sessionStorage.getItem(ssoErrors/* SSO_HANDLED_KEY */.cd) === code) return;
        sessionStorage.setItem(ssoErrors/* SSO_HANDLED_KEY */.cd, code);
        sessionStorage.setItem(SSO_LOGIN_IN_PROGRESS_KEY, '1');
        setSsoLoginInProgress(true);
        setSsoLoginFailed(false);
        var localePath = currentLocale !== 'fr' ? currentLocale : '';
        var redirectUrl = isFunnel ? localePath ? "".concat(process.env.SSO_REDIRECT_URL).concat(localePath, "/shipping") : "".concat(process.env.SSO_REDIRECT_URL_ON_FUNNEL) : "".concat(process.env.SSO_REDIRECT_URL).concat(localePath);
        var clearSsoLoginInProgress = function() {
            sessionStorage.removeItem(SSO_LOGIN_IN_PROGRESS_KEY);
            setSsoLoginInProgress(false);
        };
        if (isThermor) {
            var handleThermorSSO = function() {
                var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                    var ref, action, userAction;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                ;
                                _ctx.next = 4;
                                return atlanticLogin1(code, redirectUrl);
                            case 4:
                                action = _ctx.sent;
                                if (!((action === null || action === void 0 ? void 0 : action.type) !== 'ATLANTIC_LOGIN_SUCCESS' || !(action === null || action === void 0 ? void 0 : (ref = action.data) === null || ref === void 0 ? void 0 : ref.token))) {
                                    _ctx.next = 9;
                                    break;
                                }
                                (0,ssoErrors/* logAtlanticLoginFailure */.w$)(action);
                                redirectToSsoErrorUrl((0,ssoErrors/* extractAtlanticLoginErrorCode */.vH)(action));
                                return _ctx.abrupt("return");
                            case 9:
                                localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
                                localStorage.setItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN, action.data.token);
                                localStorage.setItem(constants/* LOCAL_STORAGE_KEYS.USER_TYPE */.dA.USER_TYPE, 'SSO');
                                _ctx.next = 14;
                                return getUser1();
                            case 14:
                                userAction = _ctx.sent;
                                if (!((userAction === null || userAction === void 0 ? void 0 : userAction.type) === 'GET_USER_FAILURE')) {
                                    _ctx.next = 19;
                                    break;
                                }
                                localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
                                redirectToSsoErrorUrl(null);
                                return _ctx.abrupt("return");
                            case 19:
                                sessionStorage.removeItem(ssoErrors/* SSO_LOGIN_FAILED_KEY */.tt);
                                // Land on the catalog rather than the homepage. Skipped in the funnel
                                // and when the account still has to go through informations-check.
                                if (!isFunnel && getMissingUserFields(userAction === null || userAction === void 0 ? void 0 : userAction.user).length === 0) {
                                    router.replace('/shop');
                                }
                                _ctx.next = 27;
                                break;
                            case 23:
                                _ctx.prev = 23;
                                _ctx.t0 = _ctx["catch"](0);
                                console.error('Thermor SSO login failed:', _ctx.t0);
                                redirectToSsoErrorUrl(null);
                            case 27:
                                _ctx.prev = 27;
                                clearSsoLoginInProgress();
                                return _ctx.finish(27);
                            case 30:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            23,
                            27,
                            30
                        ]
                    ]);
                }));
                return function handleThermorSSO() {
                    return _ref.apply(this, arguments);
                };
            }();
            handleThermorSSO();
        } else {
            var dktLogin = function() {
                var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                    var token, ref;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                _ctx.next = 3;
                                return getDKTToken1(code, redirectUrl);
                            case 3:
                                token = _ctx.sent;
                                if (!(token.type === 'GET_TOKEN_SUCCESS')) {
                                    _ctx.next = 14;
                                    break;
                                }
                                ;
                                localStorage.removeItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
                                localStorage.setItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE, process.env.SSO_TYPE);
                                localStorage.setItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN, token === null || token === void 0 ? void 0 : (ref = token.token) === null || ref === void 0 ? void 0 : ref.access_token);
                                localStorage.setItem(constants/* LOCAL_STORAGE_KEYS.USER_TYPE */.dA.USER_TYPE, 'SSO');
                                _ctx.next = 12;
                                return getUser1();
                            case 12:
                                _ctx.next = 15;
                                break;
                            case 14:
                                {
                                    sessionStorage.removeItem(ssoErrors/* SSO_HANDLED_KEY */.cd);
                                    setSsoLoginFailed(true);
                                }
                            case 15:
                                _ctx.next = 22;
                                break;
                            case 17:
                                _ctx.prev = 17;
                                _ctx.t0 = _ctx["catch"](0);
                                sessionStorage.removeItem(ssoErrors/* SSO_HANDLED_KEY */.cd);
                                setSsoLoginFailed(true);
                                console.error('DKT SSO login failed:', _ctx.t0);
                            case 22:
                                _ctx.prev = 22;
                                clearSsoLoginInProgress();
                                return _ctx.finish(22);
                            case 25:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            17,
                            22,
                            25
                        ]
                    ]);
                }));
                return function dktLogin() {
                    return _ref.apply(this, arguments);
                };
            }();
            dktLogin();
        }
    }, [
        router.isReady,
        (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.code,
        (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.product,
        (ref4 = router.query) === null || ref4 === void 0 ? void 0 : ref4.error,
        oauthCodeInUrl, 
    ]);
    (0,react.useEffect)(function() {
        var tokenExpireAt = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.TOKEN_EXPIRE_AT */.dA.TOKEN_EXPIRE_AT);
        var connexionType = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE);
        // only for CIAM - Virgin
        if (tokenExpireAt && connexionType === 'ciam') {
            var refresh = function() {
                var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return (0,services_user/* refreshToken */.g$)();
                            case 2:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 3:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function refresh() {
                    return _ref.apply(this, arguments);
                };
            }();
            var currentDate = Math.floor(new Date().getTime() / 1000);
            if (Number(tokenExpireAt) < currentDate) {
                refresh().then(function(res) {
                    localStorage.setItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN, res.access_token);
                    localStorage.setItem(constants/* LOCAL_STORAGE_KEYS.REFRESH_TOKEN */.dA.REFRESH_TOKEN, res.refresh_token);
                    localStorage.setItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN, res.expires_in);
                });
            }
        }
    }, []);
    (0,react.useEffect)(function() {
        if (typeof (user === null || user === void 0 ? void 0 : user.user) !== 'undefined' && (user === null || user === void 0 ? void 0 : user.user) !== '' && router.pathname !== '/account/informations-check') {
            var requiredFields = getMissingUserFields(user === null || user === void 0 ? void 0 : user.user);
            if (requiredFields.length > 0 && user.isLoggedIn) {
                router.push('/account/informations-check');
            }
        }
    }, [
        user === null || user === void 0 ? void 0 : user.user
    ]);
    if (shouldBlockProtectedPage) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100vw',
                height: '100vh',
                zIndex: 9999
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
        }));
    }
    return children;
};
/* harmony default export */ var SSOManager = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(SSO));


/***/ }),

/***/ 13586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wr": function() { return /* binding */ SSO_ERROR_PAGE_UID; },
/* harmony export */   "tt": function() { return /* binding */ SSO_LOGIN_FAILED_KEY; },
/* harmony export */   "cd": function() { return /* binding */ SSO_HANDLED_KEY; },
/* harmony export */   "yP": function() { return /* binding */ isKnownSsoErrorCode; },
/* harmony export */   "QQ": function() { return /* binding */ buildSsoErrorPageUrl; },
/* harmony export */   "bp": function() { return /* binding */ isSsoErrorPageRoute; },
/* harmony export */   "vH": function() { return /* binding */ extractAtlanticLoginErrorCode; },
/* harmony export */   "w$": function() { return /* binding */ logAtlanticLoginFailure; },
/* harmony export */   "_D": function() { return /* binding */ readAtlanticLoginFailureDebug; },
/* harmony export */   "g8": function() { return /* binding */ isOnSsoPage; },
/* harmony export */   "CT": function() { return /* binding */ clearSsoHandledOAuthCode; }
/* harmony export */ });
/* unused harmony exports SSO_ERROR_DEBUG_KEY, SSO_ERROR_DEFAULT, SSO_BUSINESS_ERROR_CODES, clearSsoErrorSession */
/* provided dependency */ var process = __webpack_require__(34155);
var SSO_ERROR_PAGE_UID = 'sso-login-error';
var SSO_LOGIN_FAILED_KEY = 'sso_login_failed';
var SSO_HANDLED_KEY = 'sso_handled_code';
var SSO_ERROR_DEBUG_KEY = 'sso_login_error_debug';
var SSO_ERROR_DEFAULT = 'default';
var SSO_BUSINESS_ERROR_CODES = {
    NOT_PROFESSIONAL_ACCOUNT: '41000083'
};
var KNOWN_SSO_ERROR_CODES = new Set(Object.values(SSO_BUSINESS_ERROR_CODES));
var isKnownSsoErrorCode = function(code) {
    return KNOWN_SSO_ERROR_CODES.has(code);
};
var buildSsoErrorPageUrl = function(reason) {
    var basePath = "/pages/".concat(SSO_ERROR_PAGE_UID);
    if (!reason || !isKnownSsoErrorCode(reason)) {
        return basePath;
    }
    return "".concat(basePath, "?reason=").concat(encodeURIComponent(reason));
};
var isSsoErrorPageRoute = function(pathname, uid) {
    return pathname === '/pages/[uid]' && (uid === SSO_ERROR_PAGE_UID || Array.isArray(uid) && uid[0] === SSO_ERROR_PAGE_UID);
};
var extractAtlanticLoginErrorCode = function(action) {
    var ref, ref1, ref2;
    if ((action === null || action === void 0 ? void 0 : action.type) !== 'ATLANTIC_LOGIN_FAILURE') {
        return null;
    }
    var backendCode = action === null || action === void 0 ? void 0 : (ref = action.err) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.code;
    if (backendCode == null) {
        return null;
    }
    var normalizedCode = String(backendCode);
    if (isKnownSsoErrorCode(normalizedCode)) {
        return normalizedCode;
    }
    return null;
};
/** Debug helper: logs the Atlantic login API error response in the browser console. */ var logAtlanticLoginFailure = function(action) {
    var ref, ref3, ref4, ref5;
    var responseData = action === null || action === void 0 ? void 0 : (ref = action.err) === null || ref === void 0 ? void 0 : (ref3 = ref.response) === null || ref3 === void 0 ? void 0 : ref3.data;
    var extractedCode = extractAtlanticLoginErrorCode(action);
    var debugPayload = {
        actionType: action === null || action === void 0 ? void 0 : action.type,
        httpStatus: action === null || action === void 0 ? void 0 : (ref4 = action.err) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.response) === null || ref5 === void 0 ? void 0 : ref5.status,
        responseBody: responseData,
        extractedCode: extractedCode,
        redirectUrl: buildSsoErrorPageUrl(extractedCode)
    };
    if (true) {
        sessionStorage.setItem(SSO_ERROR_DEBUG_KEY, JSON.stringify(debugPayload));
    }
    console.group('[SSO] Atlantic login failure');
    console.log('Action type:', debugPayload.actionType);
    console.log('HTTP status:', debugPayload.httpStatus);
    console.log('Response body:', debugPayload.responseBody);
    console.log('Extracted business code:', debugPayload.extractedCode);
    console.log('Redirect URL:', debugPayload.redirectUrl);
    console.groupEnd();
};
var readAtlanticLoginFailureDebug = function() {
    if (false) {}
    var raw = sessionStorage.getItem(SSO_ERROR_DEBUG_KEY);
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch (e) {
        return null;
    }
};
var isOnSsoPage = function(url) {
    if (url.includes('/pages/sso-login-error')) return true;
    if (url.includes('/pages/redirect-direct-access')) return true;
    var logoutUrl = process.env.SSO_LOGOUT_REDIRECT_URL;
    var errorUrl = process.env.SSO_ERROR_REDIRECT_URL;
    if (logoutUrl && url.includes(logoutUrl)) return true;
    if (errorUrl && url.includes(errorUrl)) return true;
    return false;
};
var clearSsoErrorSession = function() {
    sessionStorage.removeItem(SSO_LOGIN_FAILED_KEY);
    sessionStorage.removeItem(SSO_HANDLED_KEY);
};
/** Clears only the handled OAuth code so the user can retry login from the error page. */ var clearSsoHandledOAuthCode = function() {
    sessionStorage.removeItem(SSO_HANDLED_KEY);
};


/***/ })

}]);